import {Injectable} from "@angular/core";

import {CredentialsCache} from "../../../common/auth/services/service.credentials";
import {ReloadAppProvider} from "../../../app/global/services/reload.app.provider";

@Injectable()
export class CanActivateLoginGuard {
	constructor(private cred:CredentialsCache, private  reloadApp:ReloadAppProvider){
	}
	canActivate(): boolean {
		if (this.cred.isOrWasTokenSet()){
			// we are already logged in - this means we reached the login screen from within the application.
			// to fully clear the different providers from the application we need to fully refresh the page
			this.reloadApp.reloadApplication();
			return false;
		}
		return true;
	}

}
